import { jsPDF } from "jspdf";

const loadImage = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      canvas.getContext("2d").drawImage(img, 0, 0);
      resolve({ dataUrl: canvas.toDataURL("image/jpeg", 0.82), ratio: img.naturalWidth / img.naturalHeight });
    };
    img.onerror = reject;
    img.src = url;
  });

export async function downloadAircraftBrief(a) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const W = 210;
  const M = 18;

  doc.setFillColor(10, 10, 10);
  doc.rect(0, 0, W, 26, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("times", "normal");
  doc.setFontSize(15);
  doc.text("JS", M, 16);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setCharSpace(1.6);
  doc.text("PRIVATE AVIATION", M + 12, 15.2);
  doc.setCharSpace(0);
  doc.setFontSize(7);
  doc.text("AIRCRAFT BRIEF", W - M - doc.getTextWidth("AIRCRAFT BRIEF"), 15.2);

  let y = 36;
  try {
    const { dataUrl, ratio } = await loadImage(a.image);
    const w = W - 2 * M;
    const h = Math.min(w / ratio, 88);
    doc.addImage(dataUrl, "JPEG", M, y, w, h);
    y += h + 12;
  } catch {
    y += 6;
  }

  doc.setTextColor(20, 20, 20);
  doc.setFont("times", "normal");
  doc.setFontSize(26);
  doc.text(a.name, M, y);
  y += 7;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setCharSpace(1.4);
  doc.setTextColor(120, 120, 120);
  doc.text(a.category.toUpperCase(), M, y);
  doc.setCharSpace(0);
  y += 10;

  doc.setDrawColor(220, 220, 220);
  doc.line(M, y, W - M, y);
  y += 8;

  const colW = (W - 2 * M) / 3;
  const specs = [
    ["PASSENGERS", a.passengers],
    ["TYPICAL RANGE", a.range],
    ["BAGGAGE", a.baggage],
  ];
  specs.forEach(([label, value], i) => {
    doc.setFontSize(6.5);
    doc.setTextColor(140, 140, 140);
    doc.setCharSpace(1.2);
    doc.text(label, M + i * colW, y);
    doc.setCharSpace(0);
    doc.setFontSize(10);
    doc.setTextColor(25, 25, 25);
    doc.text(doc.splitTextToSize(value, colW - 6), M + i * colW, y + 6);
  });
  y += 20;

  doc.line(M, y, W - M, y);
  y += 8;
  doc.setFontSize(6.5);
  doc.setTextColor(140, 140, 140);
  doc.setCharSpace(1.2);
  doc.text("CABIN", M, y);
  doc.setCharSpace(0);
  y += 6;
  doc.setFont("times", "normal");
  doc.setFontSize(11.5);
  doc.setTextColor(50, 50, 50);
  doc.text(doc.splitTextToSize(a.cabin, W - 2 * M), M, y);
  y += 26;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  doc.setTextColor(25, 25, 25);
  doc.text("To request this aircraft, contact the charter desk:", M, y);
  y += 6;
  doc.setFont("helvetica", "bold");
  doc.text("WhatsApp +44 7459 103218   ·   Info@jsgroupholdings.com", M, y);

  doc.setFillColor(10, 10, 10);
  doc.rect(0, 272, W, 25, "F");
  doc.setFont("helvetica", "normal");
  doc.setFontSize(6);
  doc.setTextColor(160, 160, 160);
  doc.text(
    doc.splitTextToSize(
      "Aircraft examples available through our global operator network. JS Private Aviation is a private air charter brokerage and arranges flights through independent, duly licensed aircraft operators. JS Private Aviation does not own, operate or maintain aircraft. Figures are approximate manufacturer data; the specific aircraft offered is confirmed at quotation.",
      W - 2 * M
    ),
    M,
    279
  );

  doc.save(`${a.name.replace(/\s+/g, "-")}-brief.pdf`);
}
